import React, { memo } from 'react'
import { useSpring, a, config } from 'react-spring'
// import { Home } from 'components/form';
import { Header } from "components/header"
import './ChartPage.scss'
import { MoveWithForm } from 'screens/moveWithForm';
import { MoveWithCard } from 'components/card/templates/moveWith';
import { FormGroup, FormBuilder, FormControl } from 'react-reactive-form';
import { FormModel, IForm } from 'shared/model/form';
import GuageChart from 'components/guageChart/GuageChart';

export interface ChartPageProps {
  form: any;
  fh: any; 
  width: number;
  height: number;
  progress?: number;
  onBack?(): void
}

//@ts-ignore
class ChartPage extends React.Component<ChartPageProps, any> {
// function MoveWithPage({ form, fh, width, height, onBack }: MoveWithPageProps) {

  // moveWithForm: FormGroup;
  // formModel: IForm;

  constructor(props: ChartPageProps) {
    super(props);
    this.state = {
    };
    // this.moveWithForm = getMoveWithFormGroup();
    // this.formModel = new FormModel(this.props.form.formJSON, this.moveWithForm);
}

  render() {
    return (
      <a.div>
        <a.figure style={{ backgroundImage: `url(/imgs/${`99.jpg`})`,  height: this.props.fh }}>
          <GuageChart height={this.props.height}/>
        </a.figure>
        <div style={{zIndex: 2000}}>
          {/* page content here */}
        </div>
      </a.div>
    )
  }
}

export default ChartPage;

function phoneNumberValidator(formControl: FormControl) {
  // validate USA phone number
  if (!/^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/.exec(formControl.value)) {
      return { phone: true }
  } else {
      return null;
  }
}

function getMoveWithFormGroup(lead: any = {}) {

  const { MoveType, MoveSize, MoveDate, FirstName, Email, Telephone } = lead;

  return FormBuilder.group(
      {
      // MoveType: [MoveType, Validators.required],
      // MoveSize: [MoveSize, Validators.required],
      // MoveDate: [MoveDate, Validators.required],
      // FirstName: [FirstName, Validators.required],
      // Email: [Email, Validators.email],
      Telephone: ['', phoneNumberValidator],
      // done: ['']
  }
);
}